import { Container } from "./styles";
import React from "react";
import theme from "../../../Styles/theme";
import { Oval } from "react-loader-spinner";

interface Props {
  text: string;
  type: "login" | "cadastro";
  enable: boolean;
  execute: any;
  loading?: boolean;
}

export function SignInButton({
  text,
  type,
  enable,
  execute,
  loading = false,
}: Props) {
  return (
    <Container
      backgroundColor={
        type == "login" ? theme.colors.primary : theme.colors.darkGrey
      }
      onClick={execute}
    >
      {loading ? (
        <Oval color={theme.colors.light} width={"max(1.5vw, 14px)"} height={"max(1vw, 14px)"} />
      ) : (
        text
      )}
    </Container>
  );
}
